/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Guides_TitleInputs */



/**
* | output |
* | --- |
* | "KNP Guides" |
*
* @param {Knp_Manager_Guides_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_guides_title = /** @type {((inputs?: Knp_Manager_Guides_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Guides_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guides KNP")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP-Führer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guide KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Гиды КНП")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guías del KNP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("KNP 导游")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNPガイド")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी गाइड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guias do Parque Nacional Kruger")
	return /** @type {LocalizedString} */ ("KNP Guides")
});